module.exports = __webpack_public_path__ + "img/collect.a10aec1a.svg";